import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

import useIsMobile from '../../../../hooks/useIsMobile'
import { ChevronLeft } from '../../../../assets/icons'
import theme from '../../../../styles/theme'
import useFirebaseNotifications from '../../../../hooks/useFirebaseNotification'
import { useMobileBack } from '../../../../context/MobileBackContext'

const Layout = ({ children }) => {
	const isMobile = useIsMobile()
	const history = useHistory()
	const { customBack } = useMobileBack()

	const handleBack = () => {
		if (typeof customBack === 'function') {
			customBack()
			return
		}

		history.goBack()
	}

	useFirebaseNotifications({ enabled: true })

	return (
		<Container $isMobile={isMobile}>
			<Header $hidden={isMobile}>
				<Logo>Mi Portal Clínicas</Logo>
				<UserSection />
			</Header>

			<MobileHeader $visible={isMobile}>
				{typeof customBack === 'function' ? (
					<MobileHeaderButton onClick={handleBack} type="button" aria-label="Volver">
						<ChevronLeft size={15} color={theme.colors.text.primaryText} />
					</MobileHeaderButton>
				) : (
					<MobileSpacer />
				)}
				<MobileTitle>Portal clínicas</MobileTitle>
				<MobileSpacer />
			</MobileHeader>

			<ContentWrapper $isMobile={isMobile}>
				<MainContent $isMobile={isMobile}>
					<ContainerChildren $isMobile={isMobile}>{children}</ContainerChildren>
				</MainContent>
			</ContentWrapper>
		</Container>
	)
}

export default Layout

const Container = styled.div`
	min-height: 100vh;
	background-color: ${props => (props.$isMobile ? props.theme.colors.brand.white : '#f5f5f5')};
	display: flex;
	flex-direction: column;
`

const Header = styled.header`
	background-color: ${p =>
		(p.theme && p.theme.colors && p.theme.colors.brand && p.theme.colors.brand.blueOmint) || '#003d82'};
	color: white;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 24px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	position: sticky;
	top: 0;
	z-index: 100;
	display: ${props => (props.$hidden ? 'none' : 'flex')};
`

const MobileHeader = styled.header`
	background-color: white;
	padding: 1rem;
	display: ${props => (props.$visible ? 'flex' : 'none')};
	align-items: center;
	justify-content: space-between;
	position: sticky;
	top: 0;
	z-index: 100;
`

const MobileHeaderButton = styled.button`
	padding: 0.5rem;
	margin-left: -0.5rem;
	background-color: transparent;
	border: none;
	border-radius: 0.5rem;
	cursor: pointer;
	transition: background-color 0.2s;

	&:hover {
		background-color: ${props => props.theme.colors.greys.dividerGray};
	}
`

const MobileTitle = styled.h1`
	font-size: 18px;
	line-height: 24px;
	color: #000000ff;
	font-weight: 600;
	margin: 0;
`

const MobileSpacer = styled.div`
	width: 2.5rem;
	height: 1rem;
`

const Logo = styled.h1`
	font-size: 20px;
	font-weight: 600;
	margin: 0;
	color: white;
`

const UserSection = styled.div`
	position: relative;
`

const MainContent = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	padding: ${props => (props.$isMobile ? '24px 16px' : '32px')};
	background-color: #ffffff;
`

const ContainerChildren = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	margin: ${props => (props.$isMobile ? '0' : '0')};
`

const ContentWrapper = styled.div`
	display: flex;
	flex: 1;
	min-height: ${props => (props.$isMobile ? 'calc(100vh - 56px)' : 'calc(100vh - 64px)')};
`